export enum SpecialFields {
    PermissionVisualizer,
    FormsVisualizer,
    PDFVisualizer,
}
